// - In Figma: Prefix all typography font-size, font-weight, font-lineheight variables with 'font-size-', 'font-weight-', 'font-lineheight-'
// and replace underscores with hyphens, and remove mobile suffix
// - In Code: Use camelCase with underscores
// - Example:
//    - Font size:  display_lg (code) -> font-size-display-lg (figma)
//    - Font weight: semibold (code) -> font-weight-semibold (figma)
//    - Font line height: display (code) -> font-lineheight-display (figma)

export const headingFontSize = {
  heading_xxl: ['32px', '', '', '', '36px'],
  heading_xl: ['28px', '', '', '', '30px'],
  heading_lg: ['26px', '', '', '', '28px'],
  heading_md: ['23px', '', '', '', '25px'],
  heading_sm: ['20px', '', '', '', '23px'],
  heading_xs: ['18px', '', '', '', '19px'],
}

export const fontSizes = {
  // DISPLAY
  /** 48px - 68px */ display_lg: ['48px', '', '', '', '68px'],
  /** 40px - 50px */ display: ['40px', '', '', '', '50px'],
  /** 30px - 38px */ display_sm: ['30px', '', '', '', '38px'],

  // HEADINGS
  ...headingFontSize,

  // BODIES
  /** 18px */ body_lg: '18px',
  /** 16px */ body: '16px',
  /** 14px */ body_sm: '14px',

  // LABELS
  /** 14px */ label_lg: '14px',
  /** 12px */ label: '12px',
  /** 10px */ label_sm: '10px',
}

export const fontWeights = {
  semibold: 600,
  regular: 400,
} as const

export const lineHeights = {
  display: '100%',
  heading: '125%',
  body: '150%',
  label: '115%',
} as const

const typography = {
  fontSizes,
  fontWeights,
  lineHeights,
} as const

export default typography
